import * as React from 'react';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Box, Drawer, DrawerProps, Grid } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { CerebroTextButton, CerebroIcon } from '.';

// eslint-disable-next-line react/display-name
export const CerebroDrawer = React.forwardRef<HTMLDivElement, CerebroDrawerProps>(
	({ open, onClose, icon: Icon, xl, children, ...props }, ref) => (
		<Drawer
			anchor="right"
			open={open}
			onClose={onClose}
			{...props}
			PaperProps={{
				ref,
				...props.PaperProps,
				sx: {
					...(props.PaperProps as any)?.sx,
					overflowAnchor: 'none', // prevent MUI from trying to scroll to the last focused element when the drawer opens
				},
			}}
		>
			<Box
				sx={{
					maxWidth: xl ? 1250 : !Icon ? 950 : null,
					padding: 5,
					position: 'relative',
					width: { xs: '100vw', md: 'auto' },
				}}
			>
				<CerebroTextButton onClick={onClose} sx={{ position: 'absolute', top: 12, right: 12 }}>
					Close
					<CerebroIcon padLeft sx={theme => ({ color: theme.palette.primary.main })}>
						<FontAwesomeIcon icon={faTimes} size="lg" />
					</CerebroIcon>
				</CerebroTextButton>
				<Grid container direction="column" alignItems="flex-start" justifyContent="space-between">
					{Icon && (
						<Grid item sx={{ paddingBottom: 2 }}>
							<Icon width={80} height={80} />
						</Grid>
					)}
					<Grid item xs={12} sx={{ width: '100%' }}>
						{children}
					</Grid>
				</Grid>
			</Box>
		</Drawer>
	)
);

interface CerebroDrawerProps extends Omit<DrawerProps, 'anchor' | 'onClose'> {
	onClose: () => void;
	icon?: React.ComponentType<any>;
	xl?: boolean;
}
